import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const PrivateRoute = ({ children }) => {
  const { token, logoutInProgress } = useSelector((state) => state.auth)

  if (!token) {
    if (logoutInProgress) {
      return null
    }
    return <Navigate to="/login" replace />
  }

  return children
}

export default PrivateRoute
